// 获取停车场相关接口
import request from '@/utils/request'

// 获取停车场列表
export function getParkingList () {
  return request({
    url: '/market/api/parking/list',
    method: 'get'
  })
}


